/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowLeftCircle } from 'Icons';
import ConversationDetail from '../ConversationDetail/ConversationDetail';
import styles from './conversation-pages.module.css';

function ConversationsDetailPage(): React.ReactElement {
    const { t } = useTranslation(['conversationsFeature']);
    const history = useHistory();
    const { conversationId } = useParams<{ conversationId: string }>();

    const handleReturn = () => {
        history.push('/conversations');
    };

    return (
        <div className={styles.ConversationDetailPage}>
            <div onClick={handleReturn} className={styles.ConversationDetailPageHeader}>
                <ArrowLeftCircle />
                <p>{t('conversationsFeature:conversationDetail.actions.backToList')}</p>
            </div>
            <ConversationDetail conversationId={+conversationId} />
        </div>
    );
}

export default ConversationsDetailPage;
